<template>
  <div class="ratio-modal">
    <b-modal header-close-content="" @hidden="hiddenModal" centered v-model="modalState" size="lg" id="setRatio" hide-footer title="پايدا نىسپىتى تەڭشىكى">
      <b-overlay :show="formBusy" rounded="sm">
        <b-form>
          <!--<b-input-group>
            <b-form-input v-model="formData.ratio" min=1 max=100 number type="number" placeholder="پايدا نىسپەت قىممىتىنى كىرگۈزۈڭ"></b-form-input>
            <b-input-group-append>
              <b-button @click="onSubmit" size="sm" variant="primary">ساقلاش</b-button>
            </b-input-group-append>
          </b-input-group>-->
          <b-row>
            <b-col md="12" sm="6">
              <b-form-group
                      id="input-group-ratio"
                      label="پايدا نىسبىتى"
                      label-for="ratio"
              >
                <b-input-group prepend="%">
                  <b-form-spinbutton id="score" step="0.5" max="100" v-model="formData.ratio" />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="12" sm="6">
              <b-form-group
                      id="input-group-membership_ratio"
                      label="ئەزالىق پايدا نىسبىتى"
                      label-for="membership_ratio"
              >
                <b-input-group prepend="%">
                  <b-form-spinbutton id="membership_ratio" step="0.5" max="100" v-model="formData.membership_ratio" />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button @click="onSubmit" id="submit" size="sm" variant="primary">
            ساقلاش
          </b-button>
        </b-form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
  import userMixin from "../../../mixins/userMixin";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  export default {
    name: "RatioModal",
    props: {
      state: {
        type: Boolean,
        default: false
      },
      options: {
        type: Object
      },
      user: {
        type: Object
      }
    },
    mixins: [ userMixin, formBusyMixin ],
    computed: {
      modalState: {
        get(){
          return this.state;
        },
        set(v){
          return v;
        }
      }
    },
    watch: {
      options: function(newOptions) {
        // console.log(newOptions);
        this.formData = newOptions || {ratio: '', membership_ratio: '', user_id: this.user.id}
      }
    },
    data(){
      return {
        busy: false,
        formData: {
          ratio: '',
          membership_ratio: ''
        }
      };
    },
    methods: {
      hiddenModal(event){
        this.$emit('close');
      },
      onSubmit(){
        this.setRatio(this.formData)
          .then(()=> {
            this.$emit('updated');
          })
      }
    }
  }
</script>

<style scoped>

</style>
